import { homApi } from '~/redux/apis/hom'
import {
  ExamResponseDto,
  ExamResultDto,
  ExamStatsDto,
  PracticeExercise,
  RetakeResponseDto,
} from '~/tests/types/exams.types'
import { AppLanguage } from '~/types/locale'

export const mappingQuizApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    setANewExam: builder.mutation<
      ExamResponseDto,
      {
        grade: number
        gradeLabel: string
        countryCode: string
        mathTopics: Array<{ title: string; subjectOrder: number }>
        difficultyLevels: string[]
        exerciseTypes: string[]
        limitBy: {
          question: number
          time: number
        }
        version: 'v1' | 'v2'
      }
    >({
      query: (data) => ({
        url: '/v1/test-generator/start',
        method: 'POST',
        body: data,
      }),
    }),
    setRetakeExam: builder.mutation<
      RetakeResponseDto,
      {
        examId: number
      }
    >({
      query: ({ examId }) => ({
        url: `/v1/test-generator/${examId}/retake`,
        method: 'POST',
      }),
    }),
    setSubmitAnswer: builder.mutation<
      { feedback: string; is_correct: boolean },
      { examId: number; question: PracticeExercise }
    >({
      query: ({ examId, question }) => ({
        url: `/v1/test-generator/${examId}/answer`,
        method: 'POST',
        body: { ...question },
      }),
    }),

    setSubmitExam: builder.mutation<
      ExamResultDto,
      {
        examId: number
        exercises: PracticeExercise[]
        submissionTimes: Array<{
          examId: number
          exerciseId: string
          subQuestionIndex?: number
          time: string
        }>
      }
    >({
      query: ({ examId, exercises, submissionTimes }) => ({
        url: `/v1/test-generator/${examId}/submit`,
        method: 'POST',
        body: { exercises, submissionTimes },
      }),
    }),
    updateExamStatus: builder.mutation<{ status: string }, { examId: number; status: string }>({
      query: ({ examId, status }) => ({
        url: `/v1/test-generator/${examId}/update-status`,
        method: 'PATCH',
        body: { status },
      }),
    }),
    getTests: builder.query<ExamStatsDto, { limit?: number; page?: number }>({
      query: (params) => ({
        url: '/v1/test-generator/history',
        method: 'GET',
        params,
      }),
    }),
    getExercises: builder.query<{ exercises: PracticeExercise[] }, { language: AppLanguage; exerciseIds: string[] }>({
      query: ({ language, exerciseIds }) => ({
        url: `/v1/test-generator/get-exercise/${language}/${exerciseIds.join(',')}`,
        method: 'GET',
      }),
    }),
    getStats: builder.query<
      {
        stats: {
          testsTaken: number
          problemsSolved: number
          totalTimeSpentSeconds: number
          totalTimeSpentMinutes: number
        }
      },
      void
    >({
      query: () => ({
        url: '/v1/test-generator/stats',
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useSetANewExamMutation,
  useSetSubmitAnswerMutation,
  useSetSubmitExamMutation,
  useUpdateExamStatusMutation,
  useGetTestsQuery,
  useSetRetakeExamMutation,
  useGetStatsQuery,
  useGetExercisesQuery,
} = mappingQuizApi
